import { configureStore } from '@reduxjs/toolkit';

import user from './user/slice'
import currentStore from './store/slice'
import performanceIndicators from './performanceIndicators/slice'

export const store = configureStore({
  reducer: {
    currentStore,
    user,
    performanceIndicators,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
